import { render, staticRenderFns } from "./AdminJamaahBot.vue?vue&type=template&id=052c5b26&scoped=true&"
import script from "./AdminJamaahBot.vue?vue&type=script&lang=js&"
export * from "./AdminJamaahBot.vue?vue&type=script&lang=js&"
import style0 from "./AdminJamaahBot.vue?vue&type=style&index=0&id=052c5b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c5b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VProgressCircular,VRow,VTextField,VTextarea})
